$( document ).ready(function() {
  var check = false;
  var ga_interval = setInterval(checkApp, 100);
  function checkApp(){
    if($(".live-search.live-search--focused .search-flydown--results .search-flydown--product-items").length){
      check = true;
      clearInterval(ga_interval);
    }
    if(check){
      $(".live-search.live-search--focused .search-flydown--results .search-flydown--product-items .search-flydown--product").each(function(){
        if($(this).find('button.btn.button.rfq-btn.rfq-collection-btn-838').length){
        	$(this).find('.search-flydown--product-price').addClass('globoHide')
            $(this).find('button.btn.button.rfq-btn.rfq-collection-btn-838').addClass('globoHide')
        }
      })
    }
  }
  
  
  var checks = false;
  var ga_intervals = setInterval(checkApps, 100);
  function checkApps(){
    if($(".product-recommendations--container .product-section--content .productgrid--item").length){
      checks = true;
      clearInterval(ga_intervals);
    }
    if(checks){
      console.log('check')
      var scripts = $(".product-recommendations--container .product-section--content .productgrid--item .rfq-collection-script")
      for (var i=0;i<scripts.length;i++){
      	var s = document.createElement("script");
        s.type = "text/javascript";
        s.innerHTML  = scripts[i].innerHTML;
        $("head").append(s);
      }
	  GRFQApp.init(jQuery)
    }
  }
});
